(function () {
    "use strict";

    angular
        .module("sempraWebapp")
        .factory("savingsRemotePrintDialog", savingsRemotePrintDialogFactory);

    /** @ngInject */
    function savingsRemotePrintDialogFactory($mdDialog,
                                             $translate,
                                             savingsActions,
                                             organizationActions,
                                             dashboardKarcherActions,
                                             dialogsService) {
        return {
            open: openDialog
        };

        function openDialog(ev, savingsUser) {
            if (!savingsUser) {
                return Promise.resolve();
            }

            return $mdDialog.show({
                controller: RemotePrintDialogController,
                controllerAs: 'dialog',
                bindToController: true,
                templateUrl: 'app/savings/savingsRemotePrintDialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                escapeToClose: true,
                locals: {
                    savingsUser: savingsUser
                }
            });
        }

        /** @ngInject */
        function RemotePrintDialogController($mdDialog, savingsUser) {
            var dialog = this;

            dialog.savingsUser = savingsUser;
            dialog.isLoadingSites = true;
            dialog.isLoadingDevices = false;
            dialog.isSubmitting = false;
            dialog.sites = [];
            dialog.devices = [];
            dialog.selectedSite = null;
            dialog.selectedDevice = null;
            dialog.errorMessage = null;
            dialog.devicesInfoMessage = null;

            dialog.cancel = function () {
                $mdDialog.cancel();
            };

            dialog.onSiteChange = function () {
                dialog.selectedDevice = null;
                dialog.devices = [];
                dialog.devicesInfoMessage = null;
                dialog.errorMessage = null;

                if (!dialog.selectedSite) {
                    return;
                }

                loadDevices(dialog.selectedSite.id);
            };

            dialog.canSubmit = function () {
                return !!(dialog.selectedSite && dialog.selectedDevice && !dialog.isSubmitting);
            };

            dialog.submit = function () {
                if (!dialog.canSubmit()) {
                    return;
                }

                dialog.isSubmitting = true;
                dialog.errorMessage = null;

                var payload = {
                    siteId: dialog.selectedSite.id,
                    deviceId: dialog.selectedDevice.deviceId
                };

                savingsActions.printSavingsAccountRemote(dialog.savingsUser.accountId, payload)
                    .then(function (response) {
                        if (response && response.success) {
                            $mdDialog.hide();
                            dialogsService.showOkDialog('SUCCESS', 'SAVINGS_REMOTE_PRINT_SUCCESS');
                        } else {
                            dialog.errorMessage = resolveErrorMessage(response && response.errorCode);
                        }
                    })
                    .catch(function (error) {
                        var errorCode = error && error.data && error.data.errorCode;
                        dialog.errorMessage = resolveErrorMessage(errorCode);
                    })
                    .finally(function () {
                        dialog.isSubmitting = false;
                    });
            };

            function loadSites() {
                organizationActions.getAllSitesForExactUser()
                    .then(function (sites) {
                        dialog.sites = (sites || []).sort(function (a, b) {
                            return (a.name || '').localeCompare(b.name || '');
                        });
                    })
                    .catch(function () {
                        dialog.errorMessage = $translate.instant('SAVINGS_REMOTE_PRINT_ERROR_SITES');
                    })
                    .finally(function () {
                        dialog.isLoadingSites = false;
                    });
            }

            function loadDevices(siteId) {
                if (!siteId) {
                    return;
                }

                dialog.isLoadingDevices = true;
                dialog.devicesInfoMessage = null;
                dialog.errorMessage = null;

                dashboardKarcherActions.getKarcherSiteDetailsById(siteId)
                    .then(function (devices) {
                        dialog.devices = (devices || []).filter(function (device) {
                            return device && device.facilityType === 'CHANGER' && device.deviceState === 'CONNECTED';
                        });

                        if (dialog.devices.length === 0) {
                            dialog.devicesInfoMessage = $translate.instant('SAVINGS_REMOTE_PRINT_NO_CHANGERS');
                        } else {
                            dialog.devicesInfoMessage = null;
                        }
                    })
                    .catch(function () {
                        dialog.errorMessage = $translate.instant('SAVINGS_REMOTE_PRINT_ERROR_DEVICES');
                    })
                    .finally(function () {
                        dialog.isLoadingDevices = false;
                    });
            }

            function resolveErrorMessage(errorCode) {
                var errorTranslations = {
                    INVALID_REQUEST: 'SAVINGS_REMOTE_PRINT_ERROR_GENERIC',
                    DEVICE_NOT_CHANGER: 'SAVINGS_REMOTE_PRINT_ERROR_DEVICE_NOT_CHANGER',
                    DEVICE_OFFLINE: 'SAVINGS_REMOTE_PRINT_ERROR_DEVICE_OFFLINE',
                    DEVICE_NOT_ON_SITE: 'SAVINGS_REMOTE_PRINT_ERROR_DEVICE_NOT_ON_SITE',
                    PRINT_IN_PROGRESS: 'SAVINGS_REMOTE_PRINT_ERROR_IN_PROGRESS',
                    SAVINGS_PRINT_TIMEOUT: 'SAVINGS_REMOTE_PRINT_ERROR_TIMEOUT',
                    SAVINGS_PRINT_FAILED: 'SAVINGS_REMOTE_PRINT_ERROR_FAILED'
                };

                var key = errorTranslations[errorCode] || 'SAVINGS_REMOTE_PRINT_ERROR_GENERIC';
                return $translate.instant(key);
            }

            loadSites();
        }
    }
})();
